var _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_950_564",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 14.5714C19 19.7143 15.866 22 12 22C8.13401 22 5 19.7143 5 14.5714C5 9.42857 12 5.42857 12 2C12 5.42857 19 9.42857 19 14.5714Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 2C13.6 1.11634 12.8837 0.4 12 0.4C11.1163 0.4 10.4 1.11634 10.4 2H13.6ZM17.4 14.5714C17.4 16.809 16.7276 18.2108 15.8425 19.0592C14.9424 19.9221 13.6266 20.4 12 20.4V23.6C14.2394 23.6 16.4236 22.9351 18.0569 21.3693C19.7054 19.7892 20.6 17.4767 20.6 14.5714H17.4ZM12 20.4C10.3734 20.4 9.05757 19.9221 8.15745 19.0592C7.27238 18.2108 6.6 16.809 6.6 14.5714H3.4C3.4 17.4767 4.29463 19.7892 5.94305 21.3693C7.57644 22.9351 9.76059 23.6 12 23.6V20.4ZM6.6 14.5714C6.6 12.6694 7.91641 10.8129 9.72222 8.67542C10.5526 7.69254 11.5058 6.62103 12.217 5.60504C12.9152 4.60765 13.6 3.37141 13.6 2H10.4C10.4 2.34287 10.2098 2.89235 9.59548 3.76996C8.99417 4.62898 8.19742 5.52175 7.27778 6.61029C5.58359 8.61567 3.4 11.3306 3.4 14.5714H6.6ZM10.4 2C10.4 3.37141 11.0848 4.60765 11.783 5.60504C12.4942 6.62103 13.4474 7.69254 14.2778 8.67542C16.0836 10.8129 17.4 12.6694 17.4 14.5714H20.6C20.6 11.3306 18.4164 8.61567 16.7222 6.61029C15.8026 5.52175 15.0058 4.62898 14.4045 3.76996C13.7902 2.89235 13.6 2.34287 13.6 2H10.4Z",
    fill: "#FCFCFC",
    mask: "url(#path-1-inside-1_950_564)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.f05706abb45c7ce90d89cd11f0150d5d.svg";
export { ForwardRef as ReactComponent };